import gql from 'graphql-tag';
import { DeepReadonly, DeepRequired } from 'utility-types';
import { IAccount, ITodo } from '../../../../interfaces/graph-types';

// -------------------------------------------------------------------
export type TodosVariables = {
  after?: string;
  accountId: IAccount['id'];
  searchFilter?: string;
};

export type TodosQuery = DeepRequired<{
  account: IAccount;
}>;

export const todosQuery = () => gql`
  query AccountTodosAll(
    $accountId: ID!
    $after: String
    $searchFilter: String
  ) {
    account(accountId: $accountId) {
      id
      todos(after: $after, searchFilter: $searchFilter) {
        pageInfo {
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            type
            createdAt
            snoozedUntil
            completedAt
            candidate {
              id
              name
              email
              avatarUrl
              phone
              internetSpeed
            }
            funnel {
              id
              name
            }
            application {
              id
              stage
              stageName
              score
              error
              stepCount
              source
            }
          }
        }
      }
    }
  }
`;

// -------------------------------------------------------------------
export type DeleteTodosVariables = {
  todoIds: Array<ITodo['id']>;
};

export type DeleteTodosMutation = DeepReadonly<{
  error: string;
}>;

export const deleteTodosMutation = () => gql`
  mutation AccountTodoDeleteTodos($todoIds: [ID!]!) {
    deleteTodos(input: { todoIds: $todoIds }) {
      error
    }
  }
`;

// -------------------------------------------------------------------
export type CompleteTodosVariables = {
  todoIds: Array<ITodo['id']>;
};

export type CompleteTodosMutation = DeepReadonly<{
  error: string;
}>;

export const completeTodosMutation = () => gql`
  mutation AccountTodosCompleteTodos($todoIds: [ID!]!) {
    completeTodos(input: { todoIds: $todoIds }) {
      error
    }
  }
`;
